export default {
  blockobject:
    "This <name of object> is currently being edited by user <mail-address of user blocking the object> and cannot be changed right now. Please try again in 15 minutes or ask the other user to cancel the editing.",
  changedata: "Please confirm that you are entitled to change the data manually and that the new data is correct.",
  changesSavedMessage: "Your changes have been saved successfully.",
  changeobject:
    "This <name of object> has been last updated by user <mail-address of user having last updated the object> (<timestamp>). Please confirm that you are entitle",
  confirmDeleteGroup: "Do you really want to delete this group?",
  confirmDeleteRule: "Do you really want to delete this rule?",
  confirmLeaveForm: "Do you really want to leave the page? Possible changes will not be saved.",
  confirmLeaveFormTitle: "Leave page?",
  confirmLogout: "Are you sure you want to log out?",
  dataloss_1:
    "You are about to leave this page. Your entries or changes during this session will not be saved. Do you really want to leave this page? No (go back) / Yes (leave page)",
  dataloss_2: "Do you really want to delete? ",
  dataloss_2_header: "Record will be deleted!",
  header: "Warning",
  changesSaved: "Changes saved",
  logoutTitle: "Log out?",
  actionNotAllowed: "Action not allowed",
  generalErrorMessage: "Something went wrong",
  copiedToClipboard: "Copied to clipboard",
  failedToCopy: "Failed to copy",
  notAuthorized: "You are not authorized to perform this action.",
  missingAttribute: "Missing attribute",
  missingAttributeInAsset: "Some required attributes of this asset are missing values.",
};
